var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOriginator = function SvgOriginator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "originator_svg2__a",
    x1: -12,
    x2: 113,
    y1: 116.4,
    y2: -31.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#originator_svg2__a",
    id: "originator_svg2__b",
    x1: 70.2,
    x2: 195.2,
    y1: 185.8,
    y2: 37.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#originator_svg2__a",
    id: "originator_svg2__c",
    x1: 36.7,
    x2: 161.7,
    y1: 157.5,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#originator_svg2__a",
    id: "originator_svg2__d",
    x1: 44.8,
    x2: 169.8,
    y1: 164.3,
    y2: 16.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#originator_svg2__a",
    id: "originator_svg2__e",
    x1: 52.8,
    x2: 177.8,
    y1: 171.2,
    y2: 23.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#originator_svg2__a",
    id: "originator_svg2__f",
    x1: 29.1,
    x2: 154.1,
    y1: 151.1,
    y2: 3.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.4 13.5H60.2c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h24.2c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      fill: "url(#originator_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5 180.3h-4.4c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h4.4c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#originator_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6 73.8h58.8c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1H80.6c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#originator_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5 84h-81c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h81c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#originator_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4 100.4H80.6c-1.7 0-3.1 1.4-3.1 3.1s1.4 3.1 3.1 3.1h58.8c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.1-3.1-3.1",
    style: {
      strokeWidth: 0,
      fill: "url(#originator_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 29.6c-11.5 0-21 8.6-22.5 19.8h-10.3V15.6c0-8.6-7-15.6-15.6-15.6H20.9C12.3 0 5.3 7 5.3 15.6v168.8c0 8.6 7 15.6 15.6 15.6h102.6c8.6 0 15.6-7 15.6-15.6v-59.3h14.1c9 0 16.2-7.3 16.2-16.2V75c.8 0 1.7.1 2.5.1 12.5 0 22.6-10.2 22.7-22.7 0-12.5-10.2-22.7-22.7-22.7Zm-160.4-14c0-5.2 4.2-9.4 9.4-9.4h102.6c5.2 0 9.4 4.2 9.4 9.4v11.3H11.6zm112 178.1H20.9c-5.2 0-9.4-4.2-9.4-9.4V173h121.4v11.3c0 5.2-4.2 9.4-9.4 9.4Zm9.3-26.9H11.6V33.2H133v16.2H66.7c-9 0-16.2 7.3-16.2 16.2v43.1c0 9 7.3 16.2 16.2 16.2h4.4c1.1 0 2.1.6 2.7 1.5l8.7 14.2c1.8 2.8 4.8 4.4 8.1 4.3 3.2 0 6.1-1.7 7.8-4.3l8.7-14.2c.6-.9 1.6-1.5 2.6-1.5h23.2v41.8Zm30.3-58c0 5.5-4.5 10-10 10h-43.5c-3.2 0-6.3 1.7-8 4.4L93 137.4c-.6.9-1.6 1.5-2.6 1.5-1.1 0-2.1-.6-2.7-1.5L79 123.3c-1.7-2.8-4.7-4.5-8-4.5h-4.5c-5.5 0-9.9-4.6-9.8-10.1v-43c0-5.5 4.5-10 10-10h82.9c1.2 8 6.5 14.6 13.7 17.6v35.5Zm25.2-56.4c0 9.1-7.4 16.4-16.5 16.4-8.9 0-16.1-7.1-16.4-15.9v-.7c.1-9 7.4-16.3 16.5-16.2 9 .2 16.3 7.4 16.4 16.4",
    style: {
      strokeWidth: 0,
      fill: "url(#originator_svg2__f)"
    }
  }));
};
export default SvgOriginator;